<template>
  <div class="api-management-container">
    <a-page-header title="接口管理" />

    <a-card style="margin-top: 16px">
      <a-table
        :columns="columns"
        :data-source="apiList"
        :loading="loading"
        :pagination="false"
        row-key="id"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'methods'">
            <a-tag v-for="method in record.methods" :key="method" :color="getMethodColor(method)">
              {{ method }}
            </a-tag>
          </template>
          <template v-else-if="column.key === 'actions'">
            <a-space>
              <a-button type="link" size="small" @click="handleViewDoc(record)">
                查看文档
              </a-button>
              <a-button type="link" size="small" @click="handleTest(record)">
                测试
              </a-button>
            </a-space>
          </template>
        </template>
      </a-table>
    </a-card>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getAllApis } from '../utils/apiConfigs';

export default {
  name: 'ApiManagement',
  setup() {
    const router = useRouter();
    const loading = ref(false);
    const apiList = ref([]);

    const columns = [
      {
        title: '接口名称',
        dataIndex: 'name',
        key: 'name',
        width: 200
      },
      {
        title: '接口描述',
        dataIndex: 'description',
        key: 'description'
      },
      {
        title: '请求方法',
        key: 'methods',
        width: 150
      },
      {
        title: '操作',
        key: 'actions',
        width: 150
      }
    ];

    const getMethodColor = (method) => {
      const colors = {
        POST: 'blue',
        GET: 'green',
        PUT: 'orange',
        DELETE: 'red'
      };
      return colors[method] || 'default';
    };

    const handleViewDoc = (api) => {
      router.push({
        name: 'api-doc',
        params: { apiId: api.id }
      });
    };

    const handleTest = (api) => {
      router.push({
        name: 'api-test',
        params: { apiId: api.id }
      });
    };

    onMounted(() => {
      apiList.value = getAllApis();
    });

    return {
      loading,
      apiList,
      columns,
      getMethodColor,
      handleViewDoc,
      handleTest
    };
  }
};
</script>

<style scoped>
.api-management-container {
  padding: 24px;
}
</style>

